import React, { FunctionComponent, useCallback, useState } from 'react';
import { IToast } from '../util/DataModelInterface';
import { useIntl } from 'react-intl';

export type ToastHandlerContent = {
    toasts: IToast[] | null
    addToast:(error: any, type: string, operation: string) => void
    removeToast:(t: IToast) => void
  }

export const ToastHandlerContext = React.createContext<ToastHandlerContent>({
    toasts: null,
    addToast: () => {},
    removeToast: () => {},
});

interface IWrapperProps extends React.PropsWithChildren {
}

export const ToastHandlerProvider: FunctionComponent<IWrapperProps> = (props) => {
  const [toasts, setToasts] = useState([] as IToast[]);
  const intl = useIntl();

  const addToast = (error: any, type: string, operation: string) => {
    let date = new Date();
    let errText = '';
    if (type && error.errorID) {
      errText = intl.formatMessage({id: `error.errorID.${error.errorID}`});
    } else {
      errText = error.name;
    }
    let toast = {
      type: 'warning',
      title: intl.formatMessage({id: `error.${type}.${operation}`}),
      content: errText,
      info: error,
      id: date.toISOString()
    };
    console.log("setting new toast ", toast);
    setToasts( (toasts)=>[...toasts, toast]);
    return toast.id;
  }

  const removeToast = (toast: IToast) => {
    setToasts( (toasts) => toasts.filter((t) => t.id !== toast.id));
  }

  // pass everything in state to avoid creating object inside render method (like explained in the documentation)
  const state = {
    toasts: toasts,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    addToast: useCallback((error: any, type: string, operation: string) => addToast(error, type, operation), []),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    removeToast: useCallback((toast: IToast) => removeToast(toast), [])
  };

  return (
    <ToastHandlerContext.Provider value={state}>
      {props.children}
    </ToastHandlerContext.Provider>
  );
}